export const WIDTH_TRIANGLE = 8;
export const LENGTH_TRIANGLE = 7;
export const TRIANGLE_OFFSET = 8;
export const ARROW_TOP_OFFSET = 8;
export const SCREEN_OFFSET = 12;
